
import React, { useEffect, useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import HeroV2 from './home/v2/HeroV2'
import AboutSplitV2 from './home/v2/AboutSplitV2'
import StoreSplitV2 from './home/v2/StoreSplitV2'
import BusinessSplitV2 from './home/v2/BusinessSplitV2'
import ProductCarouselV2 from './home/v2/ProductCarouselV2'
import WholesaleSplitV2 from './home/v2/WholesaleSplitV2'
import HeaderV2 from '../components/HeaderV2'

const HomePageV2: React.FC = () => {
  const location = useLocation()
  const currentLang: 'zh' | 'en' = location.pathname.startsWith('/en') ? 'en' : 'zh'
  const isPreviewRoute = location.pathname.includes('/v2')

  // Inject baristamap-style fonts (EB Garamond + Noto Serif TC) once per mount
  useEffect(() => {
    const ID = 'ongu-v2-fonts'
    if (document.getElementById(ID)) return
    const link = document.createElement('link')
    link.id = ID
    link.rel = 'stylesheet'
    link.href =
      'https://fonts.googleapis.com/css2?family=EB+Garamond:ital,wght@0,400;0,500;1,400&family=Noto+Serif+TC:wght@300;400;500&display=swap'
    document.head.appendChild(link)
  }, [])

  const seo = useMemo(
    () =>
      currentLang === 'zh'
        ? {
            title: 'ONGU Studio｜自家烘焙咖啡・職人款待 (V2 預覽)',
            description:
              'ONGU Studio 是專注自家烘焙的精品咖啡工作室，結合咖啡豆商城、實體門市、B2B 批發與職人沖煮體驗。',
          }
        : {
            title: 'ONGU Studio｜In-house Coffee Roasting (V2 Preview)',
            description:
              'ONGU Studio is a specialty roastery offering single-origin beans, retail spaces, B2B wholesale, and artisan brewing experiences.',
          },
    [currentLang]
  )

  return (
    <>
      <Helmet>
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        {/* /v2 預覽路由：noindex + canonical 指正式首頁；正式接手後（無 /v2）讓搜尋引擎正常索引 */}
        {isPreviewRoute && <meta name="robots" content="noindex,nofollow" />}
        {isPreviewRoute && (
          <link rel="canonical" href={`https://www.ongucoffee.com/${currentLang}`} />
        )}
      </Helmet>

      {/* Wrap entire V2 in cream background to match Barista Map base */}
      <div
        className="bg-[#FAF9F1] text-black"
        style={{ fontFamily: "'Noto Sans TC', 'Helvetica Neue', sans-serif" }}
      >
        {/* HomePageV2 is the ONLY V2 page using transparent header (overlays Hero) */}
        <HeaderV2 variant="transparent" />

        {/* 1. Hero — full screen, extends behind transparent navbar */}
        <HeroV2 currentLang={currentLang} />

        {/* 2. About — 50/50 image-text split with paper-cream background */}
        <AboutSplitV2 currentLang={currentLang} />

        {/* 3. Stores — 60/40 asymmetric image grid (Xinyi / Branch) */}
        <StoreSplitV2 currentLang={currentLang} />

        {/* 4. Business modules — 35/65 + 50/50 image grid */}
        <BusinessSplitV2 currentLang={currentLang} />

        {/* 5. Shop — horizontal product carousel with arrows */}
        <ProductCarouselV2 currentLang={currentLang} />

        {/* 6. Wholesale — full-bleed image + paragraph block */}
        <WholesaleSplitV2 currentLang={currentLang} />
      </div>
    </>
  )
}

export default HomePageV2
